<template>
    <div class="page-audit audit-create">
        <data-form :title="pageTitle"
                   save-button-label="Submit"
                   :field-model="audit"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/"
                   submit-success-message="Audit started"
                   submit-error-message="Error creating audit">
        </data-form>
    </div>
</template>

<script>
import Vue from 'vue'
import Audit from '@/models/Audit'

export default Vue.extend({
    name: 'AuditCreate',
    props: {
        projectId: Number,
    },
    data () {
        return {
            audit: Audit,
            fieldGroups: [
                ['auditor', 'start_date']
            ],
            pageTitle: ''
        }
    },
    methods: {
        onSubmit (modelInstance) {
            modelInstance['project_id'] = this.projectId
            modelInstance['auditor_id'] = modelInstance.auditor.id
            return this.$api.createItem(this, 'audit', modelInstance)
                .then((response) => {
                    if (response.body.id) {
                        this.$router.push(`/audit/edit/${response.body.id}`)
                    }
                }, (error) => {
                    if (error && error.body && error.body.message) {
                        this.$toasted.show(error.body.message)
                    } else {
                        this.$toasted.show('Could not create audit for this project')
                    }
                    return Promise.reject() //NB: Without this the data form success message shows (but why, man?)
                })
        }
    },
    created () {
        // Authorization.can({ action: 'edit', model: 'project' })
        //     .then((can) => this.canCreate = can)
        this.$api.getItem(this, 'project', this.projectId).then((project) => {
            this.pageTitle = 'Start Audit for ' + project.name
        })
    }
})
</script>
